import axios from "axios";

function isSuccessfulResponse(response) {
    return response?.status >= 200 && response?.status < 300;
}

function normalizeCustomerCallPayload(customercall = {}) {
    const payload = {
        ...customercall,
    };

    if (payload.call_initiator !== undefined && payload.contact_type === undefined) {
        payload.contact_type = payload.call_initiator;
    }

    delete payload.call_initiator;

    return payload;
}

function normalizeSingleCustomerCallResponse(responseData) {
    if (responseData?.data && !Array.isArray(responseData.data)) {
        return responseData.data;
    }

    return responseData;
}

export default {

    namespaced: true,

    state: {

        customercalls: [],
        customerconversations: {},
        customercall: {},
        customercallshistory: {},
        employeecontactsummaryreports: [],
        followupdisciplinereports: []

    },

    getters: {

        customercalls(state) {
            return state.customercalls;
        },
        customerconversations(state) {
            return state.customerconversations;
        },
        customercall(state) {
            return state.customercall;
        },
        customercallshistory(state) {
            return state.customercallshistory;
        },
        employeecontactsummaryreports(state) {
            return state.employeecontactsummaryreports;
        },
        followupdisciplinereports(state) {
            return state.followupdisciplinereports;
        }
    },

    mutations: {

        SET_CUSTOMER_CALLS(state, customercalls) {
            return state.customercalls = customercalls
        },

        SET_CUSTOMER_CONVERSATIONS(state, customerconversations) {
            return state.customerconversations = customerconversations
        },

        SET_EMPLOYEE_CONTACT_SUMMARY_REPORT(state, employeecontactsummaryreports) {
            return state.employeecontactsummaryreports = employeecontactsummaryreports
        },

        SET_FOLLOW_UP_DISCIPLINE_REPORT(state, followupdisciplinereports) {
            return state.followupdisciplinereports = followupdisciplinereports
        },

        SET_CUSTOMER_CALL(state, customercall) {
            return state.customercall = customercall
        },

        SET_CUSTOMER_CALLS_HISTORY(state, customercallshistory) {
            return state.customercallshistory = customercallshistory
        }

    },

    actions: {

        async fetchCustomerCalls({ commit }, params) {

            await axios.get('/api/v1/customer-calls', { params: params })
                .then(res => {
                    commit('SET_CUSTOMER_CALLS', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async fetchCustomerConversations({ commit }, params) {

            await axios.get('/api/v1/customer-calls', { params: params })
                .then(res => {
                    commit('SET_CUSTOMER_CONVERSATIONS', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async fetchEmployeeContactSummaryReport({ commit }, params) {
            await axios.get('/api/v1/customer-calls/reports/employee-contact-summary', { params: params })
                .then(res => {
                    commit('SET_EMPLOYEE_CONTACT_SUMMARY_REPORT', res?.data.data || []);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async fetchFollowUpDisciplineReport({ commit }, params) {
            await axios.get('/api/v1/customer-calls/reports/follow-up-discipline', { params: params })
                .then(res => {
                    commit('SET_FOLLOW_UP_DISCIPLINE_REPORT', res?.data.data || []);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async fetchCustomerCallsHistory({ commit }, params) {

            const customerCallId = params?.customer_call_id || params?.customerCall_id;

            await axios.get(`/api/v1/customer-calls/${customerCallId}/history`, { params: params })
                .then(res => {
                    commit('SET_CUSTOMER_CALLS_HISTORY', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async fetchCustomerCall({ commit }, customer_call_id) {

            await axios.get(`/api/v1/customer-calls/${customer_call_id}`)
                .then(res => {

                    if (isSuccessfulResponse(res)) {
                        commit('SET_CUSTOMER_CALL', normalizeSingleCustomerCallResponse(res.data));
                    }
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async createCustomerCall({ dispatch }, payload) {
            const rawCustomerCall = payload?.customercall || payload;
            const customercall = normalizeCustomerCallPayload(rawCustomerCall);
            const refreshParams = payload?.refreshParams || {
                customer_id: customercall?.customer_id,
                page: 1,
                search_terms: customercall?.search_terms || "",
            };
            const refreshAction = payload?.refreshAction || 'fetchCustomerCalls';

            await axios.post('/api/v1/customer-calls', customercall)
                .then(res => {
                    if (isSuccessfulResponse(res) && refreshParams.customer_id) {
                        dispatch(refreshAction, refreshParams);
                    }
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async updateCustomerCall({ dispatch }, payload) {
            const rawCustomerCall = payload?.customercall || payload;
            const customercall = normalizeCustomerCallPayload(rawCustomerCall);
            const refreshParams = payload?.refreshParams || {
                customer_id: customercall?.customer_id,
                page: 1,
                search_terms: customercall?.search_terms || "",
            };
            const refreshAction = payload?.refreshAction || 'fetchCustomerCalls';

            await axios("/api/v1/customer-calls/" + customercall.customer_call_id, {
                method: "put",
                data: customercall,
            }).then(res => {
                if (isSuccessfulResponse(res) && refreshParams.customer_id) {
                    dispatch(refreshAction, refreshParams);
                }
            }).catch(err => {
                return Promise.reject(err);
            })

        },

        async deleteCustomerCall({ dispatch }, payload) {
            const customer_call_id = payload?.customer_call_id || payload;
            const refreshParams = payload?.refreshParams || null;
            const refreshAction = payload?.refreshAction || 'fetchCustomerCalls';

            await axios.delete(`/api/v1/customer-calls/${customer_call_id}`)
                .then(res => {
                    if (isSuccessfulResponse(res) && refreshParams?.customer_id) {
                        dispatch(refreshAction, refreshParams);
                    }
                }).catch(err => {
                    return Promise.reject(err);
                });

        }

    }

}
